import { Link } from "react-router-dom";
import TableOfContents from "./TableOfContents";
import ArticleAdSlot from "./ArticleAdSlot";

interface TocItem {
  id: string;
  label: string;
}

interface RelatedArticle {
  slug: string;
  title: string;
  image: string;
  readTime: string;
  category: string;
}

interface ArticleSidebarProps {
  tableOfContents: TocItem[];
  relatedArticles: RelatedArticle[];
}

export default function ArticleSidebar({ tableOfContents, relatedArticles }: ArticleSidebarProps) {
  return (
    <aside className="space-y-6">
      <TableOfContents items={tableOfContents} />

      <ArticleAdSlot
        slotKey="articleSidebar"
        minHeightClassName="min-h-[250px] hidden lg:block"
        scrollTriggerPercent={0.2}
      />

      <div className="bg-white border border-gray-100 rounded-2xl p-5">
        <h4 className="font-bold text-gray-800 text-sm mb-4 flex items-center gap-2">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-article-line text-orange-500"></i>
          </div>
          Artigos Relacionados
        </h4>
        <div className="space-y-4">
          {relatedArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="flex gap-3 group cursor-pointer"
            >
              <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-orange-500 text-xs font-bold">{article.category}</span>
                <p className="text-gray-700 text-xs font-semibold leading-snug mt-0.5 line-clamp-2 group-hover:text-orange-500 transition-colors">
                  {article.title}
                </p>
                <span className="text-gray-400 text-xs flex items-center gap-1 mt-1">
                  <i className="ri-time-line"></i>
                  {article.readTime}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="bg-white border border-gray-100 rounded-2xl p-5">
        <h4 className="font-bold text-gray-800 text-sm mb-3">Compartilhar</h4>
        <div className="flex gap-2">
          {[
            { icon: "ri-whatsapp-line", color: "bg-green-500 hover:bg-green-600", label: "WhatsApp" },
            { icon: "ri-facebook-circle-line", color: "bg-sky-600 hover:bg-sky-700", label: "Facebook" },
            { icon: "ri-twitter-x-line", color: "bg-gray-900 hover:bg-black", label: "X" },
            { icon: "ri-link", color: "bg-gray-200 hover:bg-gray-300 !text-gray-700", label: "Copiar" },
          ].map((s) => (
            <button
              key={s.label}
              title={s.label}
              className={`flex-1 flex items-center justify-center h-9 rounded-lg text-white text-sm transition-colors cursor-pointer ${s.color}`}
            >
              <i className={s.icon}></i>
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
}